export const list100_2025 = [
  {
    "company_id": "",
    "company_name": "莫和克工业",
    "company_name_en": "MOHAWK INDUSTRIES, INC",
    "total_revenue": "758.05",
    "product": "瓷砖、墙纸、地板等",
    "product_en": "Ceramic tile, Wallpaper, Flooring, etc.",
    "country": "美国",
    "country_en": "USA",
    "listed": "1",
    "ranking_number": "1"
  },
  {
    "company_id": "",
    "company_name": "骊住集团",
    "company_name_en": "LIXIL CORPORATION",
    "total_revenue": "654.07",
    "product": "卫浴、厨房",
    "product_en": "Sanitary ware, Kitchen",
    "country": "日本",
    "country_en": "Japan",
    "listed": "1",
    "ranking_number": "2"
  },
  {
    "company_id": "",
    "company_name": "马斯科",
    "company_name_en": "MASCO CORPORATION",
    "total_revenue": "531.52",
    "product": "卫浴、厨房",
    "product_en": "Sanitary ware, Kitchen",
    "country": "美国",
    "country_en": "USA",
    "listed": "1",
    "ranking_number": "3"
  },
  {
    "company_id": "",
    "company_name": "科勒",
    "company_name_en": "KOHLER GROUP",
    "total_revenue": "492.02",
    "product": "卫浴、五金",
    "product_en": "Sanitary ware, Hardware",
    "country": "美国",
    "country_en": "USA",
    "listed": "0",
    "ranking_number": "4"
  },
  {
    "company_id": "",
    "company_name": "维纳博艮",
    "company_name_en": "Wienerberger AG",
    "total_revenue": "378.83",
    "product": "瓷砖、水泥",
    "product_en": "Ceramic tile, Cement",
    "country": "奥地利",
    "country_en": "Austria",
    "listed": "1",
    "ranking_number": "5"
  },
  {
    "company_id": "",
    "company_name": "东陶",
    "company_name_en": "TOTO LTD",
    "total_revenue": "320.53",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "日本",
    "country_en": "Japan",
    "listed": "1",
    "ranking_number": "6"
  },
  {
    "company_id": "",
    "company_name": "富俊集团",
    "company_name_en": "FORTUNE BRANDS INNOVATIONS",
    "total_revenue": "312.13",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "美国",
    "country_en": "USA",
    "listed": "1",
    "ranking_number": "7"
  },
  {
    "company_id": "",
    "company_name": "吉博力",
    "company_name_en": "GEBERIT GROUP",
    "total_revenue": "280.73",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "瑞士",
    "country_en": "Switzerland",
    "listed": "1",
    "ranking_number": "8"
  },
  {
    "company_id": "",
    "company_name": "科罗娜",
    "company_name_en": "ORGANIZACION CORONA",
    "total_revenue": "191.79",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "哥伦比亚",
    "country_en": "Colombia",
    "listed": "0",
    "ranking_number": "9"
  },
  {
    "company_id": "",
    "company_name": "科达制造",
    "company_name_en": "KEDA INDUSTRIAL GROUP",
    "total_revenue": "173.89",
    "product": "陶瓷机械、瓷砖、洁具、玻璃",
    "product_en": "Ceramic machinery, Ceramic tile, Sanitary fixtures, Glass",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "10"
  },
  {
    "company_id": "",
    "company_name": "乐家",
    "company_name_en": "ROCA GROUP",
    "total_revenue": "161.42",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "0",
    "ranking_number": "11"
  },
  {
    "company_id": "",
    "company_name": "埃扎西巴斯集团",
    "company_name_en": "ECZACIBAŞI GROUP",
    "total_revenue": "156.47",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "土耳其",
    "country_en": "Turkey",
    "listed": "0",
    "ranking_number": "12"
  },
  {
    "company_id": "",
    "company_name": "拉莫萨集团",
    "company_name_en": "GRUPO LAMOSA",
    "total_revenue": "137.31",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "墨西哥",
    "country_en": "Mexico",
    "listed": "1",
    "ranking_number": "13"
  },
  {
    "company_id": "",
    "company_name": "萨克米",
    "company_name_en": "SACMI GROUP",
    "total_revenue": "125.67",
    "product": "机械",
    "product_en": "Machinery",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "0",
    "ranking_number": "14"
  },
  {
    "company_id": "",
    "company_name": "唯宝",
    "company_name_en": "VILLEROY&BOCH GROUP",
    "total_revenue": "119.17",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "德国",
    "country_en": "Germany",
    "listed": "1",
    "ranking_number": "15"
  },
  {
    "company_id": "",
    "company_name": "得家乐",
    "company_name_en": "TAKARA STANDARD",
    "total_revenue": "109.84",
    "product": "卫浴、厨房",
    "product_en": "Sanitary ware, Kitchen",
    "country": "日本",
    "country_en": "Japan",
    "listed": "1",
    "ranking_number": "16"
  },
  {
    "company_id": "",
    "company_name": "德克斯科",
    "company_name_en": "DEXCO",
    "total_revenue": "104.4",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "巴西",
    "country_en": "Brazil",
    "listed": "1",
    "ranking_number": "17"
  },
  {
    "company_id": "",
    "company_name": "维多利亚",
    "company_name_en": "VICTORIA PLC",
    "total_revenue": "98.59",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "英国",
    "country_en": "UK",
    "listed": "1",
    "ranking_number": "18"
  },
  {
    "company_id": "",
    "company_name": "帕米萨集团",
    "company_name_en": "GRUPO PAMESA",
    "total_revenue": "94.46",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "0",
    "ranking_number": "19"
  },
  {
    "company_id": "",
    "company_name": "康卡集团",
    "company_name_en": "Gruppo Concorde",
    "total_revenue": "94.21",
    "product": "",
    "product_en": "",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "0",
    "ranking_number": "20"
  },
  {
    "company_id": "",
    "company_name": "道氏技术",
    "company_name_en": "DOWSTONE",
    "total_revenue": "81.56",
    "product": "材料",
    "product_en": "Materials",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "21"
  },
  {
    "company_id": "",
    "company_name": "宝瓷兰",
    "company_name_en": "PORCELANOSA GRUPO",
    "total_revenue": "71.07",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "0",
    "ranking_number": "22"
  },
  {
    "company_id": "",
    "company_name": "箭牌家居",
    "company_name_en": "ARROW",
    "total_revenue": "64.74",
    "product": "卫浴、瓷砖、浴室柜等",
    "product_en": "Sanitary ware, Ceramic tile, Bathroom vanity, etc.",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "23"
  },
  {
    "company_id": "",
    "company_name": "马可波罗控股",
    "company_name_en": "MARCO POLO",
    "total_revenue": "64.58",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "24"
  },
  {
    "company_id": "",
    "company_name": "H&R约翰逊",
    "company_name_en": "PRISM JOHNSON LIMITED",
    "total_revenue": "63.92",
    "product": "瓷砖、水泥",
    "product_en": "Ceramic tile, Cement",
    "country": "印度",
    "country_en": "India",
    "listed": "1",
    "ranking_number": "25"
  },
  {
    "company_id": "",
    "company_name": "哈伊马角",
    "company_name_en": "RAK CERAMICS PJSC",
    "total_revenue": "62.8",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "阿联酋",
    "country_en": "UAE",
    "listed": "1",
    "ranking_number": "26"
  },
  {
    "company_id": "",
    "company_name": "捷奎集团",
    "company_name_en": "Jaquar Group",
    "total_revenue": "61",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "印度",
    "country_en": "India",
    "listed": "1",
    "ranking_number": "27"
  },
  {
    "company_id": "",
    "company_name": "东鹏控股",
    "company_name_en": "DONGPENG",
    "total_revenue": "60.62",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "28"
  },
  {
    "company_id": "",
    "company_name": "宏宇集团",
    "company_name_en": "HONGYU GROUP",
    "total_revenue": "60",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "29"
  },
  {
    "company_id": "",
    "company_name": "新锦成集团",
    "company_name_en": "NEW JINCHENG CERAMIC GROUP",
    "total_revenue": "60",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "30"
  },
  {
    "company_id": "",
    "company_name": "建霖家居",
    "company_name_en": "RUNNER GROUP",
    "total_revenue": "51.19",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "31"
  },
  {
    "company_id": "",
    "company_name": "SCG 装饰",
    "company_name_en": "SCG",
    "total_revenue": "49.25",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "泰国",
    "country_en": "Thailand",
    "listed": "1",
    "ranking_number": "32"
  },
  {
    "company_id": "",
    "company_name": "STN集团",
    "company_name_en": "STN GROUP",
    "total_revenue": "48.67",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "0",
    "ranking_number": "33"
  },
  {
    "company_id": "",
    "company_name": "国瓷材料",
    "company_name_en": "SINOCERA",
    "total_revenue": "45.83",
    "product": "材料",
    "product_en": "Materials",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "34"
  },
  {
    "company_id": "",
    "company_name": "蒙娜丽莎集团",
    "company_name_en": "MONALISA GROUP",
    "total_revenue": "39.23",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "35"
  },
  {
    "company_id": "",
    "company_name": "成霖",
    "company_name_en": "GLOBE UNION",
    "total_revenue": "38.78",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "中国台湾",
    "country_en": "Taiwan, China",
    "listed": "1",
    "ranking_number": "36"
  },
  {
    "company_id": "",
    "company_name": "QUA GRANITE/BIEN",
    "company_name_en": "QUA GRANITE/BIEN",
    "total_revenue": "37.88",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "土耳其",
    "country_en": "Turkey",
    "listed": "0",
    "ranking_number": "37"
  },
  {
    "company_id": "",
    "company_name": "卡加利亚陶瓷",
    "company_name_en": "KAJARIA CERAMICS",
    "total_revenue": "37.65",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "印度",
    "country_en": "India",
    "listed": "1",
    "ranking_number": "38"
  },
  {
    "company_id": "",
    "company_name": "赛珊尼",
    "company_name_en": "CERSANIT Group",
    "total_revenue": "37.09",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "波兰",
    "country_en": "Poland",
    "listed": "0",
    "ranking_number": "39"
  },
  {
    "company_id": "",
    "company_name": "NORCROS GROUP",
    "company_name_en": "NORCROS GROUP",
    "total_revenue": "37.08",
    "product": "卫浴、瓷砖、粘合剂",
    "product_en": "Sanitary ware, Ceramic tile, Adhesives",
    "country": "英国",
    "country_en": "UK",
    "listed": "1",
    "ranking_number": "40"
  },
  {
    "company_id": "",
    "company_name": "伊塔提尔",
    "company_name_en": "ITALTILE LIMITED",
    "total_revenue": "36.64",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "南非",
    "country_en": "South Africa",
    "listed": "1",
    "ranking_number": "41"
  },
  {
    "company_id": "",
    "company_name": "越南建筑玻璃与陶瓷公司",
    "company_name_en": "VIGLACERA",
    "total_revenue": "35.44",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "越南",
    "country_en": "Vietnam",
    "listed": "1",
    "ranking_number": "42"
  },
  {
    "company_id": "",
    "company_name": "弗罗润",
    "company_name_en": "FLORIM",
    "total_revenue": "34.59",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "0",
    "ranking_number": "43"
  },
  {
    "company_id": "",
    "company_name": "宝砖集团",
    "company_name_en": "PANARIA GROUP",
    "total_revenue": "33.77",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "0",
    "ranking_number": "44"
  },
  {
    "company_id": "",
    "company_name": "波托贝洛集团",
    "company_name_en": "PORTOBELLO GROUP",
    "total_revenue": "31.1",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "巴西",
    "country_en": "Brazil",
    "listed": "1",
    "ranking_number": "45"
  },
  {
    "company_id": "",
    "company_name": "天安新材",
    "company_name_en": "TIANAN NEW MATERIAL",
    "total_revenue": "30.86",
    "product": "瓷砖、高分子材料",
    "product_en": "Ceramic tile, Polymer materials",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "46"
  },
  {
    "company_id": "",
    "company_name": "惠达卫浴",
    "company_name_en": "HUIDA",
    "total_revenue": "29.44",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "47"
  },
  {
    "company_id": "",
    "company_name": "太阳陶瓷集团",
    "company_name_en": "SUN CERAMICS",
    "total_revenue": "26.25",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "48"
  },
  {
    "company_id": "",
    "company_name": "海鸥住工",
    "company_name_en": "SEAGULL",
    "total_revenue": "26.21",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "49"
  },
  {
    "company_id": "",
    "company_name": "松霖科技",
    "company_name_en": "SOLEX",
    "total_revenue": "26.2",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "50"
  },
  {
    "company_id": "",
    "company_name": "沙特陶瓷",
    "company_name_en": "SAUDI CERAMICS",
    "total_revenue": "26.01",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "沙特阿拉伯",
    "country_en": "Saudi Arabia",
    "listed": "1",
    "ranking_number": "51"
  },
  {
    "company_id": "",
    "company_name": "帝欧水华",
    "company_name_en": "DO&SHUIHUA GROUP",
    "total_revenue": "22.95",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "52"
  },
  {
    "company_id": "",
    "company_name": "大角鹿",
    "company_name_en": "DEER TILES",
    "total_revenue": "22.5",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "53"
  },
  {
    "company_id": "",
    "company_name": "卡乐集团",
    "company_name_en": "KALE GROUP",
    "total_revenue": "22.59",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "土耳其",
    "country_en": "Turkey",
    "listed": "1",
    "ranking_number": "54"
  },
  {
    "company_id": "",
    "company_name": "旭日集团（白兔瓷砖）",
    "company_name_en": "XURI GROUP",
    "total_revenue": "22.38",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "55"
  },
  {
    "company_id": "",
    "company_name": "将军陶瓷集团",
    "company_name_en": "MARSHAL CERAMICS GROUP",
    "total_revenue": "19.99",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "56"
  },
  {
    "company_id": "",
    "company_name": "索曼尼",
    "company_name_en": "SOMANY",
    "total_revenue": "21.83",
    "product": "瓷砖、卫浴",
    "product_en": "Ceramic tile, Sanitary ware",
    "country": "印度",
    "country_en": "India",
    "listed": "1",
    "ranking_number": "57"
  },
  {
    "company_id": "",
    "company_name": "罗曼企业",
    "company_name_en": "ROMANTIC ENTERPRISE",
    "total_revenue": "20.04",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "58"
  },
  {
    "company_id": "",
    "company_name": "拉米娜",
    "company_name_en": "LAMINAM",
    "total_revenue": "20.47",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "0",
    "ranking_number": "59"
  },
  {
    "company_id": "",
    "company_name": "金利源陶瓷集团",
    "company_name_en": "GOLD CERAMICS GROUP",
    "total_revenue": "19.5",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "60"
  },
  {
    "company_id": "",
    "company_name": "金卫家居",
    "company_name_en": "HINDWARE HOME INNOVATION LIMITED",
    "total_revenue": "18.67",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "印度",
    "country_en": "India",
    "listed": "1",
    "ranking_number": "61"
  },
  {
    "company_id": "",
    "company_name": "瑞阳陶瓷集团",
    "company_name_en": "RUIYANG GROUP",
    "total_revenue": "18.63",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "62"
  },
  {
    "company_id": "",
    "company_name": "瑞尔特卫浴",
    "company_name_en": "R&T",
    "total_revenue": "17.98",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "63"
  },
  {
    "company_id": "",
    "company_name": "塞拉卫浴",
    "company_name_en": "CERA SANITARYWARE",
    "total_revenue": "16.38",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "印度",
    "country_en": "India",
    "listed": "1",
    "ranking_number": "64"
  },
  {
    "company_id": "",
    "company_name": "ABK 集团",
    "company_name_en": "ABK GROUP",
    "total_revenue": "14.49",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "0",
    "ranking_number": "65"
  },
  {
    "company_id": "",
    "company_name": "AGL集团",
    "company_name_en": "ASIAN GRANITO",
    "total_revenue": "14.48",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "印度",
    "country_en": "India",
    "listed": "1",
    "ranking_number": "66"
  },
  {
    "company_id": "",
    "company_name": "朝代陶瓷",
    "company_name_en": "DYNASTY CERAMIC",
    "total_revenue": "14.04",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "泰国",
    "country_en": "Thailand",
    "listed": "1",
    "ranking_number": "67"
  },
  {
    "company_id": "",
    "company_name": "桥椿卫浴",
    "company_name_en": "SUNSPRING",
    "total_revenue": "14.02",
    "product": "卫浴五金",
    "product_en": "Bathroom hardware",
    "country": "中国台湾",
    "country_en": "Taiwan, China",
    "listed": "1",
    "ranking_number": "68"
  },
  {
    "company_id": "",
    "company_name": "KVK",
    "company_name_en": "KVK CORPORATION",
    "total_revenue": "13.84",
    "product": "卫浴、五金",
    "product_en": "Sanitary ware, Hardware",
    "country": "日本",
    "country_en": "Japan",
    "listed": "1",
    "ranking_number": "69"
  },
  {
    "company_id": "",
    "company_name": "昊晟",
    "company_name_en": "HAOSEN",
    "total_revenue": "13.3",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "70"
  },
  {
    "company_id": "",
    "company_name": "汇力瓷业",
    "company_name_en": "HUILI",
    "total_revenue": "13.26",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "71"
  },
  {
    "company_id": "",
    "company_name": "三荣",
    "company_name_en": "SANEI",
    "total_revenue": "13.01",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "日本",
    "country_en": "Japan",
    "listed": "1",
    "ranking_number": "72"
  },
  {
    "company_id": "",
    "company_name": "阿瓦娜陶瓷",
    "company_name_en": "ARWANA CITRAMULIA",
    "total_revenue": "12.21",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "印尼",
    "country_en": "Indonesia",
    "listed": "1",
    "ranking_number": "73"
  },
  {
    "company_id": "",
    "company_name": "莱西科",
    "company_name_en": "LECICO",
    "total_revenue": "11.45",
    "product": "卫浴",
    "product_en": "Sanitary ware",
    "country": "埃及",
    "country_en": "Egypt",
    "listed": "1",
    "ranking_number": "74"
  },
  {
    "company_id": "",
    "company_name": "美塔沃尔夫集团",
    "company_name_en": "Meta Wolf AG",
    "total_revenue": "11.23",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "德国",
    "country_en": "Germany",
    "listed": "1",
    "ranking_number": "75"
  },
  {
    "company_id": "",
    "company_name": "悦心健康",
    "company_name_en": "EVERJOY HEALTH GROUP",
    "total_revenue": "10.62",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "1",
    "ranking_number": "76"
  },
  {
    "company_id": "",
    "company_name": "全圣伟达",
    "company_name_en": "Quansheng Ceramics",
    "total_revenue": "10.26",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "77"
  },
  {
    "company_id": "",
    "company_name": "九牧",
    "company_name_en": "JOMOO",
    "total_revenue": "",
    "product": "卫浴、五金",
    "product_en": "Sanitary ware, Hardware",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "新明珠集团",
    "company_name_en": "NEWPEARL GROUP",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "诺贝尔",
    "company_name_en": "NABEL",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "旺康集团",
    "company_name_en": "WANGKANG",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "陶丽西",
    "company_name_en": "TORRECID",
    "total_revenue": "",
    "product": "陶瓷材料",
    "product_en": "Ceramic materials",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "杜拉维特",
    "company_name_en": "DURAVIT",
    "total_revenue": "",
    "product": "卫浴、五金",
    "product_en": "Sanitary ware, Hardware",
    "country": "德国",
    "country_en": "Germany",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "拉塞尔贝格集团",
    "company_name_en": "LASSELSBERGER GROUP",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "奥地利",
    "country_en": "Austria",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "金意陶",
    "company_name_en": "KITO",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "恒洁",
    "company_name_en": "HEGII",
    "total_revenue": "",
    "product": "卫浴、五金",
    "product_en": "Sanitary ware, Hardware",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "华硕控股",
    "company_name_en": "HUASHUO",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "罗斯福陶瓷集团",
    "company_name_en": "LUOSIFU CERAMICS GROUP",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "路达",
    "company_name_en": "LOTA",
    "total_revenue": "",
    "product": "卫浴、五金",
    "product_en": "Sanitary ware, Hardware",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "格雷麦集团",
    "company_name_en": "GRUPPO CERAMICHE GRESMALT",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "新玻尔",
    "company_name_en": "XINBOER",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "中国",
    "country_en": "China",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "阿尔塔迪亚",
    "company_name_en": "ALTADIA GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "库塔亚陶瓷",
    "company_name_en": "NG Kutahya",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "土耳其",
    "country_en": "Turkey",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "穆利亚陶瓷",
    "company_name_en": "PT Muliakeramik Indahraya",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "印尼",
    "country_en": "Indonesia",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "铂金陶瓷",
    "company_name_en": "Platinum Ceramics",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "印尼",
    "country_en": "Indonesia",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "克利奥帕特拉陶瓷集团",
    "company_name_en": "Ceramica Cleopatra Group",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "埃及",
    "country_en": "Egypt",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "ICC",
    "company_name_en": "INTERCERAMIC",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "墨西哥",
    "country_en": "Mexico",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "卡梅洛菲奥尔陶瓷",
    "company_name_en": "CERAMICA CARMELO FIOR",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "巴西",
    "country_en": "Brazil",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "塞达萨集团",
    "company_name_en": "GRUPO CEDASA",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "巴西",
    "country_en": "Brazil",
    "listed": "0",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "塞利马",
    "company_name_en": "CELIMA",
    "total_revenue": "",
    "product": "瓷砖",
    "product_en": "Ceramic tile",
    "country": "秘鲁",
    "country_en": "Peru",
    "listed": "0",
    "ranking_number": "关注"
  }
]


export const list30_2025 = [
     {
    "company_id": "",
    "company_name": "莫和克工业",
    "company_name_en": "MOHAWK",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "美国",
    "country_en": "USA",
    "listed": "",
    "ranking_number": "1"
  },
  {
    "company_id": "",
    "company_name": "康卡集团",
    "company_name_en": "Gruppo Concorde",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "",
    "ranking_number": "2"
  },
  {
    "company_id": "",
    "company_name": "拉莫萨集团",
    "company_name_en": "GRUPO LAMOSA",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "墨西哥",
    "country_en": "Mexico",
    "listed": "",
    "ranking_number": "3"
  },
  {
    "company_id": "",
    "company_name": "帕米萨集团",
    "company_name_en": "GRUPO PAMESA",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "",
    "ranking_number": "4"
  },
  {
    "company_id": "",
    "company_name": "宝瓷兰",
    "company_name_en": "PORCELANOSA GRUPO",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "",
    "ranking_number": "5"
  },
  {
    "company_id": "",
    "company_name": "特福国际",
    "company_name_en": "Twyford International",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "6"
  },
  {
    "company_id": "",
    "company_name": "马可波罗控股",
    "company_name_en": "MARCO POLO",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "7"
  },
  {
    "company_id": "",
    "company_name": "东鹏控股",
    "company_name_en": "DONGPENG",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "8"
  },
  {
    "company_id": "",
    "company_name": "宏宇陶瓷集团",
    "company_name_en": "HONGYU CERAMIC GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "9"
  },
  {
    "company_id": "",
    "company_name": "新锦成陶瓷集团",
    "company_name_en": "Newjincheng Ceramic Group",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "10"
  },
  {
    "company_id": "",
    "company_name": "STN集团",
    "company_name_en": "STN GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "西班牙",
    "country_en": "Spain",
    "listed": "",
    "ranking_number": "11"
  },
  {
    "company_id": "",
    "company_name": "SCG陶瓷",
    "company_name_en": "SCG Ceramics",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "泰国",
    "country_en": "Thailand",
    "listed": "",
    "ranking_number": "12"
  },
  {
    "company_id": "",
    "company_name": "蒙娜丽莎集团",
    "company_name_en": "MONALISA GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "13"
  },
  {
    "company_id": "",
    "company_name": "奎亚",
    "company_name_en": "QUA GRANITE",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "土耳其",
    "country_en": "Turkey",
    "listed": "",
    "ranking_number": "14"
  },
  {
    "company_id": "",
    "company_name": "哈伊马角",
    "company_name_en": "RAK CERAMICS PJSC",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "阿联酋",
    "country_en": "UAE",
    "listed": "",
    "ranking_number": "15"
  },
  {
    "company_id": "",
    "company_name": "波托贝洛集团",
    "company_name_en": "PORTOBELLO GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "巴西",
    "country_en": "Brazil",
    "listed": "",
    "ranking_number": "16"
  },
  {
    "company_id": "",
    "company_name": "弗罗润",
    "company_name_en": "FLORIM",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "",
    "ranking_number": "17"
  },
  {
    "company_id": "",
    "company_name": "宝砖集团",
    "company_name_en": "PANARIA GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "意大利",
    "country_en": "Italy",
    "listed": "",
    "ranking_number": "18"
  },
  {
    "company_id": "",
    "company_name": "卡加利亚陶瓷",
    "company_name_en": "KAJARIA CERAMICS",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "印度",
    "country_en": "India",
    "listed": "",
    "ranking_number": "19"
  },
  {
    "company_id": "",
    "company_name": "维纳博艮",
    "company_name_en": "Wienerberger AG",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "奥地利",
    "country_en": "Austria",
    "listed": "",
    "ranking_number": "20"
  },
  {
    "company_id": "",
    "company_name": "太阳集团",
    "company_name_en": "Sun Ceramics",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "21"
  },
  {
    "company_id": "",
    "company_name": "埃扎西巴斯集团",
    "company_name_en": "ECZACIBAŞI GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "土耳其",
    "country_en": "Turkey",
    "listed": "",
    "ranking_number": "22"
  },
  {
    "company_id": "",
    "company_name": "大角鹿",
    "company_name_en": "DEER TILES",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "23"
  },
  {
    "company_id": "",
    "company_name": "维多利亚",
    "company_name_en": "VICTORIA PLC",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "英国",
    "country_en": "UK",
    "listed": "",
    "ranking_number": "24"
  },
  {
    "company_id": "",
    "company_name": "旭日集团（白兔瓷砖）",
    "company_name_en": "XURI GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "25"
  },
  {
    "company_id": "",
    "company_name": "H&R约翰逊",
    "company_name_en": "PRISM JOHNSON LIMITED",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "印度",
    "country_en": "India",
    "listed": "",
    "ranking_number": "26"
  },
  {
    "company_id": "",
    "company_name": "新明珠集团",
    "company_name_en": "NEWPEARL GROUP",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "诺贝尔",
    "company_name_en": "NABEL",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "旺康集团",
    "company_name_en": "WANGKANG",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "中国",
    "country_en": "China",
    "listed": "",
    "ranking_number": "关注"
  },
  {
    "company_id": "",
    "company_name": "卡梅洛菲奥尔陶瓷",
    "company_name_en": "CERAMICA CARMELO FIOR",
    "total_revenue": "",
    "product": "",
    "product_en": "",
    "country": "巴西",
    "country_en": "Brazil",
    "listed": "",
    "ranking_number": "关注"
  }
]